import { render, staticRenderFns } from "./SetHorometer.vue?vue&type=template&id=53dc054a"
import script from "./SetHorometer.vue?vue&type=script&lang=ts"
export * from "./SetHorometer.vue?vue&type=script&lang=ts"
import style0 from "./SetHorometer.vue?vue&type=style&index=0&id=53dc054a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports